// eslint-disable-next-line no-restricted-imports
import pkgJson from '../../package.json';
import { isProduction } from 'utils/env';
import { isSSR } from 'utils/isSSR';

type Config = {
	version: string;
	isProductionBuild: boolean;
	imageCdnUrl: string;
	imageCdnManifest: string;
	assetsManifest: string;
	assetsPrefix: string;
	mapServerUrl: string;
	userTimeToLive: number;
};

const isProductionBuild = isProduction();
const staticCdnKey = isProductionBuild ? 'cdnStaticImages' : 'cdnStaticImagesTest';

function getVersion() {
	return isSSR()
		? process.env.CI_COMMIT_TAG ||
				process.env.CONF_VERSION ||
				process.env.CI_COMMIT_SHA ||
				`${pkgJson.name}/${pkgJson.version}`
		: (globalThis.document?.querySelector('meta[name="version"]')?.getAttribute('content') ?? '');
}

const config: Config = {
	version: getVersion(),
	isProductionBuild,
	imageCdnUrl: pkgJson[staticCdnKey]?.rootPath ?? '',
	imageCdnManifest: pkgJson[staticCdnKey]?.manifest ?? '',
	assetsManifest: isSSR() ? (process.env.ASSETS_MANIFEST ?? '') : '',
	assetsPrefix: isSSR() ? (process.env.ASSETS_PREFIX ?? '') : '',
	mapServerUrl: '/static/mapy-compose',
	userTimeToLive: Number(import.meta.env.USER_TIME_TO_LIVE ?? '100'), // ms per user
} as const;

// eslint-disable-next-line no-console
console.info('version', config.version);
if (isSSR()) {
	// eslint-disable-next-line no-console
	console.log('config', config);
}

export default config;
